import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';
import {WeightGridKey} from './WeightGridKey';
import {WeightGridLine} from './WeightGridLine';

export class WeightGrid extends BasicEntity {
code: string;
description: TranslatedEmb;
endDate: number | null;
label: TranslatedEmb;
startDate: number | null;
visionCode: string;
weightGridKeys: WeightGridKey[];
weightGridLines: WeightGridLine[];
}

